export default __webpack_public_path__ + "static/media/bancontact.9f0dd0be.svg";